import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextTooltipOnHover from '../../../Popover/TextTooltipOnHover';
import FolderSyncIcon from '../../../Icons/FolderSync';
import BiLink from '../../../biLogger/Components/BiLink';
import cardStyles from '../../FolderCard.scss';
import s from './FolderSyncIndicator.scss';
var FolderSyncIndicator = function (props) {
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(cardStyles['subfolders-icon'], cardStyles['icon-with-tooltip'], cardStyles['wix-portfolio-sync-feature'], s['root']) },
        React.createElement(TextTooltipOnHover, { tooltipText: React.createElement("div", { className: s['tooltip-content'] },
                t('wixPortfolio.folderSync.synced'),
                ' ',
                React.createElement(BiLink, { className: s['edit-link'], href: "/wixsite/edit", onClick: function (e) { return e.stopPropagation(); }, target: "_blank" }, t('common.edit'))) },
            React.createElement(FolderSyncIcon, { disableDefaultColors: true }))));
};
FolderSyncIndicator.displayName = 'FolderSyncIndicator';
export default FolderSyncIndicator;
//# sourceMappingURL=FolderSyncIndicator.js.map